<template>
  <vs-popup class="popup-planificacion" :title="(modoEdicion ? 'Editar' : 'Nueva') + ' Planificación'"
    :active.sync="modalVisible" @close="$emit('close')">
    <div class="popup-body">
      <!-- {{ planificacion.fecha_captura_longitud_fin != null }} -->
      <!-- Sección de Institución (simplificada para mobile) -->
      <div class="form-section">
        <label class="section-title">Institución</label>

        <div v-if="!formulario.institucion_id && !formulario.institucion_id_temporal">
          <div class="inst-buttons">
            <vs-button @click="tipoInstitucion = 'normal'" :color="tipoInstitucion === 'normal' ? 'primary' : 'dark'"
              :type="tipoInstitucion === 'normal' ? 'filled' : 'flat'" size="small"
              class="inst-btn">Registradas</vs-button>
            <vs-button @click="tipoInstitucion = 'temporal'"
              :color="tipoInstitucion === 'temporal' ? 'primary' : 'dark'"
              :type="tipoInstitucion === 'temporal' ? 'filled' : 'flat'" size="small"
              class="inst-btn">Temporales</vs-button>
          </div>

          <div v-if="tipoInstitucion === 'normal'" class="search-box">
            <vs-input v-model="busquedaInstitucion" placeholder="Buscar institución (mín. 5 caracteres)..."
              class="w-full" @keyup.enter="buscarInstituciones" />
            <vs-button @click="buscarInstituciones" color="primary" size="small" class="mt-2">Buscar</vs-button>
          </div>

          <div v-if="tipoInstitucion === 'temporal'" class="temporal-actions">
            <vs-button @click="abrirModalTemporal" color="success" type="border" size="small">Nueva Temporal</vs-button>
            <vs-button @click="cargarTemporales" color="primary" type="border" size="small">Mis Temporales</vs-button>
          </div>

          <!-- Resultados de búsqueda -->
          <div v-if="instituciones.length > 0" class="instituciones-list">
            <div class="list-header">
              <span>{{ instituciones.length }} instituciones encontradas</span>
              <button @click="cerrarListaInstituciones" class="btn-close-list">×</button>
            </div>
            <div v-for="inst in instituciones" :key="inst.id" @click="seleccionarInstitucion(inst)"
              class="institucion-item">
              <div class="inst-info">
                <div class="inst-nombre">{{ inst.nombre }}</div>
                <div class="inst-ciudad">{{ inst.ciudad || 'Sin ciudad' }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Institución seleccionada -->
        <div v-else class="institucion-seleccionada">
          <div class="selected-card">
            <div class="selected-info">
              <span class="selected-label">Institución:</span>
              <span class="selected-name">{{ formulario.nombre_institucion }}</span>
            </div>
            <button @click="limpiarInstitucion" class="btn-remove" v-if="!planificacionFinalizada">×</button>
          </div>
        </div>
      </div>

      <!-- Campos del formulario -->
      <div class="form-section">
        <label class="section-title">Título *</label>
        <input type="text" v-model="formulario.titulo" placeholder="Título de la actividad" class="form-input" />
      </div>

      <div class="form-section">
        <label class="section-title">Observaciones</label>
        <textarea v-model="formulario.descripcion" placeholder="observaciones adicionales de la visita (opcional)"
          class="form-textarea" rows="3"></textarea>
      </div>

      <div class="form-row">
        <div class="form-section">
          <label class="section-title">Fecha *</label>
          <input type="date" v-model="formulario.fecha" class="form-input" :readonly="planificacionFinalizada" />
        </div>
        <div class="form-section">
          <label class="section-title">Hora *</label>
          <input type="time" v-model="formulario.hora" class="form-input" :readonly="planificacionFinalizada" />
        </div>
      </div>

      <!-- Opciones de actividad -->
      <div class="form-section">
        <label class="section-title">Opciones de Actividad</label>
        <div class="opciones-grid">
          <label v-for="op in opcionesList" :key="op.key" class="checkbox-label"
            :class="{ 'disabled': planificacionFinalizada }">
            <input type="checkbox" v-model="opciones[op.key]" :disabled="planificacionFinalizada" />
            <span>{{ op.nombre }}</span>
          </label>
        </div>

        <div v-if="opciones.otraEditorial" class="editorial-input">
          <label class="form-label">Nombre de la Editorial *</label>
          <input type="text" v-model="opciones.editorial" class="form-input" placeholder="Escriba la editorial"
            :readonly="planificacionFinalizada" :class="{ 'disabled-input': planificacionFinalizada }" />
        </div>
      </div>

      <!-- Botones de acción -->
      <div class="form-actions">
        <vs-button @click="guardar" color="success" type="gradient" block>
          {{ modoEdicion ? 'Actualizar' : 'Guardar' }}
        </vs-button>
        <vs-button @click="$emit('close')" color="danger" type="border" block>Cancelar</vs-button>
      </div>
    </div>

    <!-- Modal para crear institución temporal -->
    <vs-popup class="popup-temporal" title="Nueva Institución Temporal" :active.sync="mostrarFormularioTemporal"
      @close="cerrarModalTemporal">
      <div class="popup-body-temporal">
        <div class="form-group">
          <label>Nombre de la Institución *</label>
          <input type="text" v-model="institucionTemporal.nombre" placeholder="Ingrese el nombre de la institución"
            class="form-input" />
        </div>

        <div class="form-group">
          <label>Región *</label>
          <select v-model="institucionTemporal.region" @change="cargarPeriodos" class="form-select">
            <option value="1">Sierra</option>
            <option value="2">Costa</option>
          </select>
        </div>

        <div class="form-group">
          <label>Ciudad *</label>
          <select v-model="institucionTemporal.ciudad" class="form-select">
            <option :value="null">Seleccione una ciudad</option>
            <option v-for="ciudad in arregloCiudades" :key="ciudad.idciudad" :value="ciudad">
              {{ ciudad.nombre }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label>Período *</label>
          <select v-model="institucionTemporal.periodo" class="form-select">
            <option :value="null">Seleccione un período</option>
            <option v-for="periodo in arregloPeriodos" :key="periodo.id" :value="periodo.id">
              {{ periodo.nombre }}
            </option>
          </select>
        </div>

        <div class="popup-footer-temporal">
          <vs-button @click="crearInstitucionTemporal" color="success" type="gradient">
            Guardar Institución
          </vs-button>
          <vs-button @click="cerrarModalTemporal" color="danger" type="border">
            Cancelar
          </vs-button>
        </div>
      </div>
    </vs-popup>
  </vs-popup>
</template>

<script>
export default {
  name: 'PlanificacionFormModal',
  props: {
    visible: Boolean,
    modoEdicion: Boolean,
    usuario: Object,
    planificacion: Object
  },
  data() {
    return {
      modalVisible: this.visible,
      formulario: {
        id: null,
        titulo: '',
        descripcion: '',
        fecha: '',
        hora: '',
        institucion_id: null,
        institucion_id_temporal: null,
        nombre_institucion: '',
        estado_institucion_temporal: 0,
        periodo_id: null,
        estadoNumerico: 0
      },
      tipoInstitucion: 'normal',
      busquedaInstitucion: '',
      instituciones: [],
      opciones: {
        presentacion: false,
        entrega_muestras: false,
        reunion: false,
        seguimiento: false,
        cierre: false,
        cobranza: false,
        post_venta: false,
        retiro_cartas: false,
        retiro_muestras: false,
        capacitacion: false,
        otraEditorial: false,
        editorial: ''
      },
      opcionesList: [
        { key: 'presentacion', nombre: 'Presentación' },
        { key: 'entrega_muestras', nombre: 'Entrega Muestras' },
        { key: 'reunion', nombre: 'Reunión' },
        { key: 'seguimiento', nombre: 'Seguimiento' },
        { key: 'cierre', nombre: 'Cierre' },
        { key: 'cobranza', nombre: 'Cobranza' },
        { key: 'post_venta', nombre: 'Post Venta' },
        { key: 'retiro_cartas', nombre: 'Retiro Cartas' },
        { key: 'retiro_muestras', nombre: 'Retiro Muestras' },
        { key: 'capacitacion', nombre: 'Capacitación' },
        { key: 'otraEditorial', nombre: 'Otra Editorial' }
      ],
      mostrarFormularioTemporal: false,
      institucionTemporal: {
        nombre: '',
        ciudad: null,
        region: '2',
        periodo: null
      },
      arregloCiudades: [],
      arregloPeriodos: [],
      institucionSeleccionada: false,
    }
  },
  watch: {
    visible(val) {
      this.modalVisible = val
      if (val && this.planificacion) {
        this.cargarPlanificacion()
      } else if (val) {
        this.resetForm()
        this.cargarCiudades()
      }
    }
  },
  computed: {
    planificacionFinalizada() {
      return this.planificacion && this.planificacion.fecha_captura_longitud_fin != null;
    }
  },
  methods: {
    cargarPlanificacion() {
      this.formulario = { ...this.planificacion }
      this.opciones = this.planificacion.opciones || {
        presentacion: false,
        entrega_muestras: false,
        reunion: false,
        seguimiento: false,
        cierre: false,
        cobranza: false,
        post_venta: false,
        retiro_cartas: false,
        retiro_muestras: false,
        capacitacion: false,
        otraEditorial: false,
        editorial: ''
      }

      if (this.planificacion.datosCompletos && this.planificacion.datosCompletos.otraEditorial) {
        this.opciones.editorial = this.planificacion.datosCompletos.otraEditorial
        if (this.opciones.editorial) {
          this.opciones.otraEditorial = true
        }
      }

      if (this.formulario.institucion_id || this.formulario.institucion_id_temporal) {
        this.institucionSeleccionada = true
      }
    },

    resetForm() {
      const ahora = new Date()
      this.formulario = {
        id: null,
        titulo: '',
        descripcion: '',
        fecha: ahora.toISOString().split('T')[0],
        hora: ahora.toTimeString().slice(0, 5),
        institucion_id: null,
        institucion_id_temporal: null,
        nombre_institucion: '',
        estado_institucion_temporal: 0,
        periodo_id: null,
        estadoNumerico: 0
      }
      this.opciones = {
        presentacion: false,
        entrega_muestras: false,
        reunion: false,
        seguimiento: false,
        cierre: false,
        cobranza: false,
        post_venta: false,
        retiro_cartas: false,
        retiro_muestras: false,
        capacitacion: false,
        otraEditorial: false,
        editorial: ''
      }
      this.instituciones = []
      this.busquedaInstitucion = ''
      this.tipoInstitucion = 'normal'
      this.institucionSeleccionada = false
    },

    cerrarListaInstituciones() {
      this.instituciones = []
    },

    async buscarInstituciones() {
      if (this.busquedaInstitucion.length < 5) {
        this.$vs.notify({
          title: 'Validación',
          text: 'Debe escribir al menos 5 caracteres para buscar',
          color: 'warning'
        })
        return
      }

      this.$vs.loading({ text: 'Buscando instituciones...' })

      try {
        const url = this.$server_url + 'listaInsitucionAsesor?busqueda=' + this.busquedaInstitucion + '&todasInstituciones=yes'
        const response = await this.$http.get(url)

        if (response.data.length > 0) {
          this.instituciones = response.data.map(inst => ({
            id: inst.idInstitucion,
            nombre: inst.nombreInstitucion,
            ciudad: inst.ciudad || 'Sin ciudad',
            nombre_asesor: (inst.nombre_asesor ? inst.nombre_asesor + ' ' + (inst.apellido_asesor || '') : 'Sin asesor').trim(),
            tipo: 'normal'
          }))
        } else {
          this.instituciones = []
          this.$vs.notify({
            title: 'Información',
            text: 'No se encontraron instituciones',
            color: 'primary'
          })
        }
      } catch (error) {
        console.error('Error:', error)
        this.$vs.notify({
          title: 'Error',
          text: 'Error al buscar instituciones',
          color: 'danger'
        })
      } finally {
        this.$vs.loading.close()
      }
    },

    async cargarTemporales() {
      this.$vs.loading({ text: 'Cargando instituciones temporales...' })

      try {
        const url = this.$server_url + 'listaInsitucionAsesor?temporales=yes&asesor_id=' + this.usuario.idusuario
        const response = await this.$http.get(url)

        if (response.data.length > 0) {
          this.instituciones = response.data.map(inst => ({
            id: inst.institucion_temporal_id,
            nombre: inst.nombreInstitucion || inst.nombre_institucion || 'Sin nombre',
            ciudad: inst.ciudad || 'Sin ciudad',
            nombre_asesor: (inst.nombre_asesor ? inst.nombre_asesor + ' ' + (inst.apellido_asesor || '') : 'Sin asesor').trim(),
            periodo_id: inst.periodo_id,
            tipo: 'temporal'
          }))
        } else {
          this.instituciones = []
          this.$vs.notify({
            title: 'Información',
            text: 'No tiene instituciones temporales creadas',
            color: 'primary'
          })
        }
      } catch (error) {
        console.error('Error:', error)
        this.$vs.notify({
          title: 'Error',
          text: 'Error al cargar instituciones temporales',
          color: 'danger'
        })
      } finally {
        this.$vs.loading.close()
      }
    },

    seleccionarInstitucion(inst) {
      if (inst.tipo === 'normal') {
        this.formulario.institucion_id = inst.id
        this.formulario.institucion_id_temporal = null
        this.formulario.estado_institucion_temporal = 0
        this.formulario.nombre_institucion = inst.nombre
        this.formulario.periodo_id = null
      } else {
        this.formulario.institucion_id = null
        this.formulario.institucion_id_temporal = inst.id
        this.formulario.estado_institucion_temporal = 1
        this.formulario.nombre_institucion = inst.nombre
        this.formulario.periodo_id = inst.periodo_id
      }

      this.institucionSeleccionada = true
      this.instituciones = []
      this.busquedaInstitucion = ''

      this.$vs.notify({
        title: 'Éxito',
        text: 'Institución seleccionada correctamente',
        color: 'success'
      })
    },

    limpiarInstitucion() {
      this.formulario.institucion_id = null
      this.formulario.institucion_id_temporal = null
      this.formulario.estado_institucion_temporal = 0
      this.formulario.nombre_institucion = ''
      this.formulario.periodo_id = null
      this.institucionSeleccionada = false
      this.instituciones = []
      this.busquedaInstitucion = ''
    },

    abrirModalTemporal() {
      this.mostrarFormularioTemporal = true
      this.cargarCiudades()
      this.cargarPeriodos()
    },

    cerrarModalTemporal() {
      this.mostrarFormularioTemporal = false
      this.institucionTemporal = {
        nombre: '',
        ciudad: null,
        region: '2',
        periodo: null
      }
    },

    async cargarCiudades() {
      try {
        const response = await this.$http.get(this.$server_url + 'ciudad')
        this.arregloCiudades = response.data
      } catch (error) {
        console.error('Error cargando ciudades:', error)
      }
    },

    async cargarPeriodos() {
      try {
        const response = await this.$http.get(this.$server_url + 'get_periodos_pedidos')
        this.arregloPeriodos = response.data
          .filter(p => p.estado == 1 && p.region_idregion == this.institucionTemporal.region)
          .map(p => ({
            id: p.idperiodoescolar,
            nombre: p.periodoescolar
          }))
      } catch (error) {
        console.error('Error cargando periodos:', error)
      }
    },

    async crearInstitucionTemporal() {
      if (!this.institucionTemporal.nombre || this.institucionTemporal.nombre.trim() === '') {
        this.$vs.notify({
          title: 'Validación',
          text: 'El nombre de la institución es obligatorio',
          color: 'warning'
        })
        return
      }

      if (!this.institucionTemporal.ciudad) {
        this.$vs.notify({
          title: 'Validación',
          text: 'Debe seleccionar una ciudad',
          color: 'warning'
        })
        return
      }

      if (!this.institucionTemporal.periodo) {
        this.$vs.notify({
          title: 'Validación',
          text: 'Debe seleccionar un periodo',
          color: 'warning'
        })
        return
      }

      this.$vs.loading({ text: 'Creando institución temporal...' })

      try {
        let formData = new FormData()
        formData.append('nombre_institucion', this.institucionTemporal.nombre)
        formData.append('ciudad', this.institucionTemporal.ciudad.nombre)
        formData.append('region', this.institucionTemporal.region)
        formData.append('periodo', this.institucionTemporal.periodo)
        formData.append('asesor_id', this.usuario.idusuario)

        const response = await this.$http.post(this.$server_url + 'GuardarInstitucionTemporal', formData)

        if (response.data.status === 0) {
          this.$vs.notify({
            title: 'Advertencia',
            text: response.data.message,
            color: 'warning'
          })
          return
        }

        this.formulario.institucion_id = null
        this.formulario.institucion_id_temporal = response.data.institucion_temporal_id
        this.formulario.estado_institucion_temporal = 1
        this.formulario.nombre_institucion = this.institucionTemporal.nombre
        this.formulario.periodo_id = response.data.periodo_id

        this.institucionSeleccionada = true
        this.cerrarModalTemporal()

        this.$vs.notify({
          title: 'Éxito',
          text: 'Institución temporal creada exitosamente',
          color: 'success'
        })
      } catch (error) {
        console.error('Error:', error)
        this.$vs.notify({
          title: 'Error',
          text: 'Error al crear institución temporal',
          color: 'danger'
        })
      } finally {
        this.$vs.loading.close()
      }
    },

    guardar() {
      if (!this.validarFormulario()) return

      const formData = new FormData()

      if (this.modoEdicion) {
        if (!this.formulario.id) {
          console.error('Error: No hay ID de planificación para editar')
          this.$vs.notify({
            title: 'Error',
            text: 'No se puede actualizar: ID de planificación no encontrado',
            color: 'danger'
          })
          return
        }
        formData.append('_method', 'PUT')
      }

      formData.append('title', this.formulario.titulo)
      formData.append('startDate', this.formulario.fecha)
      formData.append('hora_inicio', this.formulario.hora)
      formData.append('hora_fin', this.formulario.hora)
      formData.append('endDate', this.formulario.fecha)
      formData.append('url', this.formulario.descripcion || '')
      formData.append('usuario_creador', this.usuario.idusuario)
      formData.append('estado', this.formulario.estadoNumerico || 0)

      const opcionesSinEditorial = { ...this.opciones }
      delete opcionesSinEditorial.editorial
      formData.append('opciones', JSON.stringify(opcionesSinEditorial))

      if (this.opciones.otraEditorial) {
        formData.append('nombre_editorial', this.opciones.editorial)
      }

      if (this.formulario.institucion_id) {
        formData.append('institucion_id', this.formulario.institucion_id)
        formData.append('estado_institucion_temporal', '0')
      }
      if (this.formulario.institucion_id_temporal) {
        formData.append('institucion_id_temporal', this.formulario.institucion_id_temporal)
        formData.append('nombre_institucion_temporal', this.formulario.nombre_institucion)
        formData.append('estado_institucion_temporal', '1')
      }
      if (this.formulario.periodo_id) {
        formData.append('periodo_id', this.formulario.periodo_id)
      }

      this.$emit('save', {
        formData: formData,
        id: this.modoEdicion ? this.formulario.id : null
      })
    },

    validarFormulario() {
      if (!this.formulario.institucion_id && !this.formulario.institucion_id_temporal) {
        this.$vs.notify({ title: 'Validación', text: 'Debe seleccionar una institución', color: 'warning' })
        return false
      }
      if (!this.formulario.titulo) {
        this.$vs.notify({ title: 'Validación', text: 'El título es obligatorio', color: 'warning' })
        return false
      }
      if (!this.formulario.fecha || !this.formulario.hora) {
        this.$vs.notify({ title: 'Validación', text: 'Fecha y hora son obligatorias', color: 'warning' })
        return false
      }

      const opcionesSeleccionadas = Object.entries(this.opciones).some(([key, val]) =>
        key !== 'editorial' && val === true
      )
      if (!opcionesSeleccionadas) {
        this.$vs.notify({ title: 'Validación', text: 'Debe seleccionar al menos una opción', color: 'warning' })
        return false
      }

      if (this.opciones.otraEditorial && !this.opciones.editorial) {
        this.$vs.notify({ title: 'Validación', text: 'Debe escribir el nombre de la editorial', color: 'warning' })
        return false
      }

      return true
    }
  }
}
</script>

<style scoped>
.popup-body {
  padding: 0.5rem 0;
}

.form-section {
  margin-bottom: 1.25rem;
}

.section-title {
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  color: #334155;
  margin-bottom: 0.5rem;
}

.form-input,
.form-textarea {
  width: 100%;
  padding: 0.75rem;
  border: 2px solid #e2e8f0;
  border-radius: 0.5rem;
  font-size: 0.9375rem;
  font-family: inherit;
}

.form-input:focus,
.form-textarea:focus {
  outline: none;
  border-color: #2563eb;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
}

.inst-buttons {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}

.inst-btn {
  flex: 1;
}

.search-box {
  margin-top: 0.5rem;
}

.temporal-actions {
  display: flex;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.instituciones-list {
  max-height: 250px;
  overflow-y: auto;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  margin-top: 0.75rem;
}

.institucion-item {
  padding: 0.75rem;
  border-bottom: 1px solid #f1f5f9;
  cursor: pointer;
}

.institucion-item:last-child {
  border-bottom: none;
}

.institucion-item:hover {
  background: #f8fafc;
}

.inst-nombre {
  font-weight: 600;
  font-size: 0.875rem;
}

.inst-ciudad {
  font-size: 0.75rem;
  color: #64748b;
}

.institucion-seleccionada {
  margin-top: 0.5rem;
}

.selected-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem;
  background: #f0fdf4;
  border: 1px solid #86efac;
  border-radius: 0.5rem;
}

.selected-info {
  display: flex;
  flex-direction: column;
}

.selected-label {
  font-size: 0.7rem;
  color: #059669;
}

.selected-name {
  font-weight: 600;
  color: #064e3b;
}

.btn-remove {
  width: 1.75rem;
  height: 1.75rem;
  border: none;
  border-radius: 50%;
  background: white;
  color: #dc2626;
  font-size: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.opciones-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.5rem;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  font-size: 0.8rem;
}

.checkbox-label input {
  width: 1rem;
  height: 1rem;
}

.editorial-input {
  margin-top: 0.75rem;
}

.form-actions {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 1.5rem;
}

.btn-remove-disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}
</style>
